import Vue from 'vue'
import VueRouter from 'vue-router'
/* import Home from './views/Home.vue'
import PessoaFisica from './views/PessoaFisica.vue'
import Contato from './views/Contato.vue'
import PessoaJuridica from './views/PessoaJuridica.vue'*/
/* import ServidorPublico from './views/ServidorPublico.vue'  */
import PessoaFisica from './views/PessoaFisica.vue'
import PessoaJuridica from './views/PessoaJuridica.vue'
import ContratoPF from './views/ContratoPF.vue'
import ContratoPJ from './views/ContratoPJ.vue'
/* import ContratoSP from './views/ContratoSP.vue' */
import AreaCliente from './views/AreaCliente.vue'
import Inclusao from './views/Inclusao.vue'
import ConfirmCompany from './views/ConfirmCompany.vue'
import Auth from './auth/Auth.vue'
import { userKey } from '@/global'

Vue.use(VueRouter)

const routes = [{
  /* name: 'home',
  path: '/',
  component: Home,
}, {
  name: 'pessoafisica',
  path: '/pessoa-fisica',
  alias: '/pessoafisica',
  component: PessoaFisica
}, {
  name: 'pessoajuridica',
  path: '/pessoa-juridica',
  alias: '/pessoajuridica',
  component: PessoaJuridica
}, {
  name: 'servidorpublico',
  path: '/servidor-publico',
  alias: '/servidorpublico',
  component: ServidorPublico
}, {
  name: 'contato',
  path: '/contato',
  component: Contato
}, { */
  name: 'home',
  path: '/',
  alias: '/pessoafisica',
  component: PessoaFisica
}, {
  name: 'pessoajuridica',
  path: '/pessoa-juridica',
  alias: '/pessoajuridica',
  component: PessoaJuridica
},
{
  name: 'contratopf',
  path: '/contratopf',
  component: ContratoPF
}/* , {
  name: 'pessoajuridica',
  path: '/pessoa-juridica',
  alias: '/pessoajuridica',
  component: PessoaJuridica
} */, {
  name: 'pessoafisica',
  path: '/pessoa-fisica',
  alias: '/pessoafisica',
  component: PessoaFisica
}, {
  name: 'contratopj',
  path: '/contratopj',
  component: ContratoPJ
}/* ,
 {
  name: 'servidorpublico',
  path: '/servidor-publico',
  alias: '/servidorpublico',
  component: ServidorPublico
}, {
  name: 'contratopj',
  path: '/contratopj',
  component: ContratoPJ
},{
  name: 'contratosp',
  path: '/contratosp',
  component: ContratoSP
} */, {
  name: 'areacliente',
  path: '/areacliente',
  component: AreaCliente
}, {
  name: 'auth',
  path: '/login',
  component: Auth
}, {
  name: 'confirmcompany',
  path: '/confirmcompany',
  component: ConfirmCompany
}, {
  name: 'inclusao',
  path: '/inclusao',
  component: Inclusao
}
]

const router = new VueRouter({
  mode: 'history',
  routes
})

//Controla segurança de rotas
router.beforeEach((to, from, next) => {
  const json = localStorage.getItem(userKey)

  if(to.matched.some(record => record.meta.requiresAdmin)) {
      const user = JSON.parse(json)
      if(user === "ADMIN")
       next()
       else
       next({ path: '/login' })
  } else {
      next()
  }
})

export default router
